export const LIVE_PENDING_ALERTS_COLUMNS = [
    'mode', 'type', 'time', 'symbol', 'algo', 'lots', 'types'
]

export const PAPER_PENDING_ALERTS_COLUMNS = [
    'mode', 'time', 'symbol', 'algo', 'lots', 'types'
]

export const ACTIVE_ALGOS_COLUMNS = [
    'algo_name', 'algo_category', 'algo_id', 'scrip_name', 'mode_of_execution', 'quantity', 'algo_activation_time', 'actions'
]
export const PENDING_ALERTS_COLUMNS = [
    'icon', 'order_mode', 'alert_time', 'scrip_name', 'algo_category', 'algo_name', 'algo_id', 'quantity', 'type'
]

export const ALERTS_PAGE_COLUMNS = [
    'mode_of_execution', 'algo_type', 'algo_category', 'algo_name', 'order_mode', 'scrip_name',
    'ltp', 'alert_time', 'algo_id', 'quantity', 'condition', 'condition_status'
];
